const CATEGORY_ICON_BASE = "/images/home/categories";

const CATEGORY_ICON_PATHS: Record<string, string> = {
  plumbing: `${CATEGORY_ICON_BASE}/plumbing.svg`,
  plumbers: `${CATEGORY_ICON_BASE}/plumbing.svg`,
  electricians: `${CATEGORY_ICON_BASE}/electricians.svg`,
  electrical: `${CATEGORY_ICON_BASE}/electricians.svg`,
  interior_renovation: `${CATEGORY_ICON_BASE}/interior_renovation.svg`,
  construction: `${CATEGORY_ICON_BASE}/construction.svg`,
  cleaning: `${CATEGORY_ICON_BASE}/cleaning.svg`,
  professional_cleaning: `${CATEGORY_ICON_BASE}/cleaning.svg`,
  heating_cooling: `${CATEGORY_ICON_BASE}/heating_cooling.svg`,
  hvac: `${CATEGORY_ICON_BASE}/heating_cooling.svg`,
  roofing: `${CATEGORY_ICON_BASE}/roofing.svg`,
  appliance_repair: `${CATEGORY_ICON_BASE}/appliance_repair.svg`,
  facade: `${CATEGORY_ICON_BASE}/facade.svg`,
  windows: `${CATEGORY_ICON_BASE}/windows.svg`,
  doors: `${CATEGORY_ICON_BASE}/doors.svg`,
  tiling: `${CATEGORY_ICON_BASE}/tiling.svg`,
  flooring: `${CATEGORY_ICON_BASE}/flooring.svg`,
  concrete_foundations: `${CATEGORY_ICON_BASE}/concrete_foundations.svg`,
  furniture_assembly: `${CATEGORY_ICON_BASE}/furniture_assembly.svg`,
  furniture_manufacturing: `${CATEGORY_ICON_BASE}/furniture_manufacturing.svg`,
  woodworking: `${CATEGORY_ICON_BASE}/woodworking.svg`,
  fencing: `${CATEGORY_ICON_BASE}/fencing.svg`,
  terraces: `${CATEGORY_ICON_BASE}/terraces.svg`,
  earthworks: `${CATEGORY_ICON_BASE}/earthworks.svg`,
  paving: `${CATEGORY_ICON_BASE}/paving.svg`,
  landscaping: `${CATEGORY_ICON_BASE}/landscaping.svg`,
  welding_metal_fabrication: `${CATEGORY_ICON_BASE}/welding_metal_fabrication.svg`,
  machining: `${CATEGORY_ICON_BASE}/machining.svg`,
  security_systems: `${CATEGORY_ICON_BASE}/security_systems.svg`,
};

export function getCategoryIconPath(category: string) {
  return CATEGORY_ICON_PATHS[category] || null;
}
